<template>
   <div class="modal-card">

        <b-loading :is-full-page=true v-model="isLoadingFullPage" ></b-loading>

        <!-- <header class="modal-card-head">
 


        </header> -->
        <section class="modal-card-body">


               


                    <b-field label="Select a date" grouped  >
                    <p class="control">
                        <span class="button is-static">Start</span>
                    </p>       
                    <b-datepicker v-model="dateStart"
                                    :first-day-of-week="1"
                                    placeholder="Click to select...">

                                    <b-button
                                        label="Today"
                                        type="is-primary"
                                        icon-left="calendar-today"
                                        @click="dateStart = new Date()" />

                                   
                                </b-datepicker>


                    <p class="control">
                        <span class="button is-static">To</span>
                    </p>  

                    <p class="control">
                    <b-datepicker v-model="dateStop"
                                    :first-day-of-week="1"
                                    placeholder="Click to select...">

                                    <b-button
                                        label="Today"
                                        type="is-primary"
                                        icon-left="calendar-today"
                                        @click="dateStop = new Date()" />

                                 
                                </b-datepicker>
                    </p>
        </b-field>

        <b-field  label="Date Type"><!-- Label left empty for spacing -->
              <b-switch v-model="dateType"
                true-value=1
                false-value=2>
                <p v-if="dateType == 1 ">Date Request</p>
                <p v-else>Date Report</p>
                 
             </b-switch>
             
        </b-field>



        <b-field ><!-- Label left empty for spacing -->
            <p class="control">
                <b-button label="Gen Report L01" 
                type="is-success" 
                @click="genReportL01"
                />
            </p>
        </b-field>



        </section>
        <footer class="modal-card-foot"  style="justify-content: space-between;">
 
            <b-button type="is-danger" @click="close">Close</b-button>
 
        </footer>
    </div>
</template>



<script>
import { DateTime } from "luxon";
import moment from "moment";
import axios from "axios";
import {   getBaseURLforBackEnd  , getConfigAxios     } from '@/utils.js'



export default {
    name : "ReportL01",
    created() {
        const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
            this.close()

            next(false)
        })

        this.$once('hook:destroyed', () => {
            unregisterRouterGuard()
        })
    },
    props:{
        isShowing : Boolean,
    },
    methods:{
        genReportL01(){

            //  const diffDate = findDiffDate(this.dateStart,this.dateStop)
                var dateStart = moment(this.dateStart);
                var dateStop = moment(this.dateStop);
                const diffDate =    dateStop.diff(dateStart, 'days')  
                    //   console.log('diffDate--->',diffDate);

              if ( diffDate>=0 &&  diffDate<=31)  {
                        const datTo = {
                        "date_start": DateTime.utc((new Date(this.dateStart)).getFullYear(), (new Date(this.dateStart)).getMonth()+1, (new Date(this.dateStart)).getDate()).toISO()  ,
                        "date_stop": DateTime.utc((new Date(this.dateStop)).getFullYear(), (new Date(this.dateStop)).getMonth()+1, (new Date(this.dateStop)).getDate()).toISO(),
                        "date_type" : this.dateType == 1 ? 1 : 2 
                    }

                    // console.log('datTo--->',JSON.stringify(datTo));
                    const vm = this
                                this.isFullScreenSearching = true
                                axios.post(`${getBaseURLforBackEnd()}/api/reportl01`,datTo,getConfigAxios())
                                    .then(function (response) {
                                        vm.isFullScreenSearching = false
                                        vm.$buefy.toast.open({
                                            duration: 5000,
                                            message: `${response.data.msg}`,
                                            position: 'is-bottom',
                                            type: 'is-success'
                                        })
                                        // vm.close()
                                    })
                                    .catch((err)=>{
                                            this.$buefy.dialog.alert({
                                                                        title: 'Error',
                                                                        message: `${err.message}`,
                                                                        type: 'is-danger',
                                                                        hasIcon: true,
                                                                        icon: 'alert-circle-outline',
                                                                        ariaRole: 'alertdialog',
                                                                        ariaModal: true
                                                                    })
                                    })
                             






              }else{
                 this.$buefy.dialog.alert({
                        title: 'Error',
                        message: `pls select date request between 31 days  ( your select date between  ${diffDate} days)`,
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'alert-circle-outline',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
              }
            
        },
        close(){
          this.$emit('close')
        },
    },
    data(){
        return{
            isLoadingFullPage : false,
            dateStart : new Date() ,
            dateStop : new Date() ,
            dateType : 1,
        }
    }
}
</script>